module.exports = function() {
  return new Worker(__webpack_public_path__ + "a3126dde3e8ae1782103.worker.js");
};